import { Services } from "../../services/Services.js";
import { Control } from "../Control.js";

export class Group extends Control {

    constructor(parent, options = {}) {

        options = Object.assign({
            width: 12,
            controls: [],
            inline: false
        }, options || {});

        super(parent, options);

        const {
            width = 12,
            controls = [],
            inline = false
        } = options;

        this.width = width;
        this.controls = controls;
        this.inline = inline;

    };

    render(vm) {

        const ct = Services.get('templates');

        var props = {
            visible: this.isVisible(),
        },
            style = (ct.width(this.width) || '') + (this.getCss() || ''),
            nodes = this.controls.map(function (control) {
                if (!control)
                    return null;
                return control.render(vm);
            });

        return ct.group(style, props, nodes);

    };

}